var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gj-select',_vm._g(_vm._b({attrs:{"options":_vm.active ? _vm.activeSupplier : _vm.supplier,"placeholder":_vm.placeholder,"type":_vm.multiple ? 'multi-check' : 'default'}},'gj-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }